import React from 'react'
import styled from 'styled-components'
import { mixinInputFormClasses } from 'spa/member/styles/mixin'
import { useFormContext, Controller } from 'react-hook-form'
import { FormErrorMessage } from '../FormErrorMessage'
import { OptionType, SelectProps } from './types'

const StyledSelectContainer = styled.div<{ $inputSize?: 'default' | 'small'}>`
  position: relative;

  &::after {
    font-family: 'Material Symbols Outlined';
    content: '\\e313';
    position: absolute;
    top: ${props => props.$inputSize === 'small' ? 'calc(50% - 9.5px)' : 'calc(50% - .75rem)'};
    right: 12px;
    color: var(--color-member-gray-100);
    pointer-events: none;
    font-size: 1rem;
    line-height: ${props => props.$inputSize === 'small' ? '21px' : '1.5'};
  }
`

export const StyledSelect: React.FC<SelectProps> = props => {
  const { control, formState: { errors } } = useFormContext()

  const hasError = !!errors[props.name]
  const showErrorMessage = props.showErrorMessage !== false

  const baseClassName = 'appearance-none bg-member-white-100 text-member-black-100 leading-normal!'
  const className = [baseClassName, props.className || '', mixinInputFormClasses(hasError, props.inputSize)].filter(Boolean).join(' ')

  const groupedOptions: Record<string, OptionType[]> = props.options.reduce((acc, option) => {
    const key = option.optgroup || ''
    acc[key] = acc[key] || []
    acc[key].push(option)
    return acc
  }, {})

  return (
    <div>
      <Controller
        name={props.name}
        control={control}
        rules={props.rules}
        render={({ field }) => (
          <>
            <StyledSelectContainer $inputSize={props.inputSize || 'default'}>
                <select
                  {...field}
                  {...Object.fromEntries(Object.entries(props).filter(([key, _value]) => !['options', 'rules', 'inputSize', 'showErrorMessage'].includes(key)))}
                  className={className}
                  onChange={e => {
                    field.onChange(e);
                    props.onChange && props.onChange(e)}}
                >
                  {/* optgroupごとにまとめて表示 */}
                  {/* optgroupなしのoption */}
                  {(groupedOptions[''] || []).map((option, idx) => (
                    <option key={`nogroup-${idx}`} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                  {/* optgroupごとのoption */}
                  {Object.entries(groupedOptions)
                    .filter(([groupLabel]) => groupLabel !== '')
                    .map(([groupLabel, options]) => (
                      <optgroup key={groupLabel} label={groupLabel}>
                        {(options as OptionType[]).map((option, idx) => (
                          <option key={`group-${groupLabel}-${idx}`} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </optgroup>
                    ))}
              </select>
            </StyledSelectContainer>
            {showErrorMessage && hasError && <FormErrorMessage message={String(errors[props.name]?.message)} />}
          </>
        )}
      />
    </div>
  )
}
